import styled from 'styled-components';
import { codeStyles } from '../../styles/code';

// Shared styles for all <code> tags
export const CodeWithFontStyles = styled('code')`
  font-family: ${codeStyles.fontFamily};
  font-weight: ${codeStyles.fontWeight};
  font-size: ${codeStyles.fontSize};
`;

// <code> that gets rendered by `md` (grey)
export const CodeWithAllStyles = styled(CodeWithFontStyles)`
  font-family: ${codeStyles.fontFamily};
  font-weight: ${codeStyles.fontWeight};
  font-size: 14px;
  line-height: 24px;
  background: #f1f1f1;
  border-radius: 4px;
  padding: 2px 6px;
  white-space: pre-wrap;
  word-break: break-word;
`;
